import { ref, onUnmounted } from "vue";
import useMyFetch from "@stores/useMyFetch";

export const useEmailEditor = ({ editorFrame, editorUrl, onTemplateSaved }) => {
  const iframeReady = ref(false);

  const onIframeLoad = () => {
    setTimeout(() => (iframeReady.value = true), 500);
  };

  const sendMessageToEditor = (message) => {
    if (!editorFrame.value?.contentWindow) return;

    editorFrame.value.contentWindow.postMessage(message, editorUrl);
  };

  const loadTemplate = (templateJsonContent) => {
    if (!iframeReady.value) return;

    const jsonContent = JSON.parse(JSON.stringify(templateJsonContent));
    sendMessageToEditor({ type: "LOAD_TEMPLATE", json: jsonContent });
  };

  const base64ToBlob = (base64, mimeType) => {
    const base64Data = base64.includes(",") ? base64.split(",").pop() : base64;
    const byteCharacters = atob(base64Data);
    const byteArray = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteArray[i] = byteCharacters.charCodeAt(i);
    }
    return new Blob([byteArray], { type: mimeType });
  };

  const handleImageUpload = async (uploadRequest) => {
    const { blockId, file, fileName, fileType } = uploadRequest;

    try {
      const blob = base64ToBlob(file, fileType);
      const fileObj = new File([blob], fileName, { type: fileType });
      const formData = new FormData();
      formData.append("file[attachment]", fileObj);
      formData.append("file[path]", "email-templates");

      const { response, data } = await useMyFetch("/file_uploads")
        .post(formData)
        .json();

      if (response.value.ok) {
        sendMessageToEditor({
          type: "IMAGE_UPLOADED",
          blockId: blockId,
          url: data.value.url,
        });
      } else {
        sendMessageToEditor({
          type: "IMAGE_UPLOAD_ERROR",
          blockId: blockId,
          error: data.value?.error || "Upload failed",
        });
      }
    } catch (error) {
      sendMessageToEditor({
        type: "IMAGE_UPLOAD_ERROR",
        blockId: blockId,
        error: "Network error. Please try again.",
      });
    }
  };

  const handleMessageFromEditor = (event) => {
    // Vérifier l'origine
    if (event.origin !== editorUrl) return;

    const messageType = event.data?.type;

    if (messageType === "SAVE_TEMPLATE" && event.data?.json && event.data?.html) {
      if (onTemplateSaved) {
        onTemplateSaved({
          json: event.data.json,
          html: event.data.html,
        });
      }
    }

    else if (messageType === "UPLOAD_IMAGE") {
      handleImageUpload(event.data);
    }
  };

  window.addEventListener("message", handleMessageFromEditor);

  onUnmounted(() => {
    window.removeEventListener("message", handleMessageFromEditor);
  });

  return {
    iframeReady,
    onIframeLoad,
    loadTemplate,
    sendMessageToEditor,
  };
};
